import { render, staticRenderFns } from "./VerifyEmailModal.vue?vue&type=template&id=10d15fa8&scoped=true"
import script from "./VerifyEmailModal.vue?vue&type=script&lang=js"
export * from "./VerifyEmailModal.vue?vue&type=script&lang=js"
import style0 from "./VerifyEmailModal.vue?vue&type=style&index=0&id=10d15fa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d15fa8",
  null
  
)

export default component.exports